/**
 * Created by ganlu on 08/11/2016.
 */
export default ($compile, $parse) => {
    'ngInject';
    return {
        require: 'ngModel',
        link: function (scope, elem, attrs, ctrl) {
            let alert, ttScope = scope.$new(true), alertLinkedScope;
            const model = $parse(attrs['ngModel']);
            const template = `
                             <div class="password-alert">
                                <div class="arrow"></div>
                                <div class="inner">
                                    <p>{{ 'face-user-text014' | translate }}</p>
                                    <div class="demands">
                                        <div ng-class="{success: len, error: !len}">
                                            <i class="ybicon" ng-class="{'yb-succeed': len, 'yb-close': !len}"></i>{{ 'face-user-text015' | translate }}</div>
                                        <div ng-class="{success: UpAndLower, error: !UpAndLower}">
                                            <i class="ybicon" ng-class="{'yb-succeed': UpAndLower, 'yb-close': !UpAndLower}"></i>{{ 'face-user-text016' | translate }}</div>
                                        <div ng-class="{success: symbol, error: !symbol}">
                                            <i class="ybicon" ng-class="{'yb-succeed': symbol, 'yb-close': !symbol}"></i>{{ 'face-user-text017' | translate }}</div>
                                        <div ng-class="{success: number, error: !number}">
                                            <i class="ybicon" ng-class="{'yb-succeed': number, 'yb-close': !number}"></i>{{ 'face-user-text018' | translate }}</div>
                                    </div>
                                    <div class="meter">
                                        <p>{{ 'face-user-text019' | translate }}: {{levelLocaleName | translate}}</p>
                                        <div class="progress">
                                            <div class="bar" ng-class="level" ng-style="{width: score + '%'}"></div>
                                        </div>
                                        <p class="desc">{{ 'face-user-text023' | translate }}</p>
                                    </div>
                                </div>
                            </div>`
            const linker = $compile(template);
            function createAlert () {
                if (alert) {
                    return;
                }
                alertLinkedScope = ttScope.$new();
                if (angular.isDefined(model(scope))) {
                    valid(model(scope), alertLinkedScope);
                }
                alert = linker(alertLinkedScope, function (a) {
                    elem.after(a)
                })
            }

            function removeAlert () {
                if (alert) {
                    alert.remove();
                    alert = null;
                }
                if (alertLinkedScope) {
                    alertLinkedScope.$destroy();
                    alertLinkedScope = null;
                }
            }

            function showAlertBind () {
                createAlert()
            }

            function hideAlertBind () {
                removeAlert()
            }

            function valid(value, scope) {
                if (value.length >= 8) {
                    scope.len = true;
                } else {
                    scope.len = false;
                }
                if (/[A-Z]/.test(value) && /[a-z]/.test(value)) {
                    scope.UpAndLower = true;
                } else {
                    scope.UpAndLower = false;
                }
                if (/[`~!@#$^&*()+=|\\\[\]\{\}:;'\,.<>/?]/.test(value)) {
                    scope.symbol = true;
                } else {
                    scope.symbol = false;
                }
                if (/\d/.test(value)) {
                    scope.number = true;
                } else {
                    scope.number = false;
                }
                evaluate(alertLinkedScope)
            }

            function evaluate (linkedScope) {
                let score = 0;
                if (linkedScope.len) {
                    score ++;
                }
                if (linkedScope.UpAndLower) {
                    score ++;
                }
                if (linkedScope.symbol) {
                    score ++;
                }
                if (linkedScope.number) {
                    score ++;
                }
                linkedScope.score = 25 * score;
                linkedScope.level = ['', 'low', 'medium', 'medium', 'high'][score];
                linkedScope.levelLocaleName = ['', 'face-user-text020', 'face-user-text021', 'face-user-text021', 'face-user-text022'][score];
                if (score === 4) {
                    ctrl.$setValidity('pwdStrength', true);
                } else {
                    ctrl.$setValidity('pwdStrength', false);
                }
            }

            scope.$watch(model, function (newV, oldV) {
                if (angular.isDefined(newV)) {
                    valid(newV, alertLinkedScope)
                }
            })

            elem.on('focus', showAlertBind);
            elem.on('blur', hideAlertBind);
        }
    };
}



// WEBPACK FOOTER //
// ./src/app/common/form/pwdStrength.directive.js